import React from 'react'

const AuthenticationContext = React.createContext(null)
export default AuthenticationContext
